
import Group from 'vux/src/components/group/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import $ from 'jquery';
export default {
components: {
Group,
XButton,
XHeader,
XAddress,
Toast,
CheckIcon,
XSwitch
},
data () {
return {
phoneNum:"",
adrName:"",
addressData: ChinaAddressV4Data,
showToast: false,
value: [],
showAddress: false,
defaultadd:false,
area : "",
city : "",
detail : "",
ownerId : "",
addressId:"",
province : "",
receiverName : "",
zipCode: "",
address:"",
provinceDetail:"",
toastText:"",
demo1:false,
addId:"",
addIndex:"",
addTitle:""
}
},
created() {
let owner=JSON.parse(localStorage.getItem("ownerData"));
this.ownerId=owner.ownerId;
let id=this.$route.params.id;
let index=this.$route.params.index;
console.log(id);
if(id){
this.addId=id;
this.addIndex=index;
this.addTitle="修改地址";
this.$vux.loading.show({
text: '加载中',
})

this.getOwnerAddress();
}else{
this.addTitle="新增地址";
}
},
mounted(){


},
methods:{
getOwnerAddress(){
var that=this;
this.BM.JQajax({
url:this._Api.getAddress,
method:"GET",



success: function(data) {
console.log(data);
if(data.data && that.addId){
let addData=data.data[that.addIndex];
that.phoneNum=addData.receiverPhone;
that.province=addData.province;
that.adrName=addData.receiverName;
that.zipCode=addData.zipCode;
that.address=addData.detail;
that.area=addData.area;
that.city=addData.city;
that.addressId=addData.id;
if(addData.isDefault==0){
that.demo1=true
}
}
that.$vux.loading.hide();
},
error:function(data){
that.toastText="获取地址信息失败";
that.showToast = true;

},
unAuth:function(){
that.toastText="验证失败，请重新登录";
that.showToast = true;
setTimeout(function(){
localStorage.removeItem('loginData');
that.$router.push({
path: '/'
});
}.bind(this),1000)

}
})
},
saveAddress(){
var that=this;
let loginData=JSON.parse(localStorage.getItem("loginData"));
var token;
var defaultAdd;
var addressData1;
if(loginData){
token= loginData.token_type+" "+loginData.access_token;
}
this.$vux.loading.show({
text: '正在保存',
})
if(!this.area|| !this.city||!this.address||!this.province||!this.adrName||!this.phoneNum){
this.showToast = true;
this.toastText="请输入完整信息";
return;
}
if(this.demo1){
defaultAdd=0
}else{
defaultAdd=1
}
if(this.addId){
addressData1={
"area" :that.area,
"city" : that.city,
"detail" : that.address,

"province" : that.province,
"receiverName" :that.adrName,
"zipCode": that.zipCode,
"receiverPhone": that.phoneNum,
"isDefault": defaultAdd,
"id":this.addId,

}
}else{
addressData1={
"area" :that.area,
"city" : that.city,
"detail" : that.address,

"province" : that.province,
"receiverName" :that.adrName,
"zipCode": that.zipCode,
"receiverPhone": that.phoneNum,
"isDefault": defaultAdd,

}
}
$.ajax({
url : this._Api.saveAddress,
type: "POST",
contentType:"application/json",
data:JSON.stringify(addressData1),
beforeSend: function(xhr) {
xhr.setRequestHeader("Authorization", token);
},
success: function(res) {
console.log(res);
if(res.code==200){
that.toastText="保存成功";
that.showToast = true;
setTimeout(function(){
that.$router.push({
path: '/chargeAdd'
});
}.bind(this),500)
that.$vux.loading.hide();
}else{
that.toastText=res.msg
that.showToast = true;
}

},

error:function(res){
that.toastText="保存失败";
that.$vux.loading.hide();

},
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/update.vue